<template>
  <div>
    <h2>NBN</h2>
    <ag-grid-vue
      domLayout="autoHeight"
      class="ag-theme-balham"
      :columnDefs="columnDefs"
      :rowData="rowData"
      :defaultColDef="defaultColDef"
      @first-data-rendered="onFirstDataRendered"
    ></ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
export default {
  name: "nbn",
  props: {
    rowData: {
      type: Array,
      default: () => [],
    },
    ratePlans: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    AgGridVue,
  },
  data: () => ({
    columnDefs: [],
  }),
  beforeMount() {
    let vm = this
    vm.setColumnDefs();
    vm.defaultColDef = {
      resizable: true,
      autoHeight: true
    };
  },
  methods: {
    setColumnDefs() {
      let vm = this;
      vm.columnDefs = [
        { headerName: "Service Number", field: "serviceNumber" },
        { headerName: "Contract Length", field: "contractTerm" },
        {
          headerName: "Plan",
          field: "ratePlanID",
          width: 300,
          cellRenderer: function(params) {
            const plan = vm.ratePlans.filter(
              (x) => x.ratePlanID === parseInt(params.value)
            );

            return plan.length > 0 ? plan[0].ratePlanDescription : "";
          },
        },
        { headerName: "4G Backup", field: "bundleId" },
      ];
    },
    onFirstDataRendered (grid) {
      grid.api.sizeColumnsToFit();
    }
  },
};
</script>
